import React from 'react'
import PlacesLoader from '../_load/PlaceLoader'
import { useQrcodePlaceId } from '../_load/QrcodeLoader'
import PlacePageHeader from './linktree/PlacePageHeader'
import LinkTreeItemsLoader from './linktree/_load/LinkTreeItemsLoader'
import LinkTreeMenu from './linktree/LinktreeMenu'

const PlacePage = () => {
  const placeId = useQrcodePlaceId()

  return (
    <PlacesLoader id={placeId}>
      <PlacePageHeader />
      <LinkTreeItemsLoader>
        <LinkTreeMenu />
      </LinkTreeItemsLoader>
    </PlacesLoader>
  )
}

export default PlacePage
